import { getSportsAssetsUrl } from '@/libraries/url';

declare global {
    interface Window {
        __dynamic_base__: string;
    }
}

window.__dynamic_base__ = getSportsAssetsUrl();
